// LC 진단테스트(입회) 학습자 API. 모든 id는 string(BigInt 안전).
import { apiClient, ApiResponse } from './client'

export type DiagnosticStatus =
  | 'ASSIGNED' | 'AIQ_IN_PROGRESS' | 'LEVEL_GRADING' | 'COMPLETED' | 'CANCELLED'

export interface DiagnosticView {
  id: string
  status: DiagnosticStatus
}

export interface PendingDiagnosticResponse {
  pendingDiagnostic: DiagnosticView | null
}

export interface AiqStartResponse {
  quizIds: string[]
  nextSeq: number
}

export interface AiqSubmitRequest {
  quizId: string
  answers: unknown[]
  vars: Record<string, unknown>
  elapsedSec: number
  elapsedMs?: number
}

export interface AiqSubmitResponse {
  isCorrect: boolean
  corrects: Array<boolean | null>
  correctAnswers: unknown[]
  description: { text?: string } | null
}

export const learnerDiagnosticsApi = {
  getMine: () =>
    apiClient.get<ApiResponse<PendingDiagnosticResponse>>('/lc/my/diagnostic'),

  startAiq: () =>
    apiClient.post<ApiResponse<AiqStartResponse>>('/lc/my/diagnostic/aiq/start'),

  submitResponse: (body: AiqSubmitRequest) =>
    apiClient.post<ApiResponse<AiqSubmitResponse>>('/lc/my/diagnostic/aiq/responses', body),

  completeAiq: () =>
    apiClient.post<ApiResponse<null>>('/lc/my/diagnostic/aiq/complete'),

  acknowledge: () =>
    apiClient.post<ApiResponse<null>>('/lc/my/diagnostic/acknowledge'),
}
